import { render, staticRenderFns } from "./SSN.vue?vue&type=template&id=04086586&"
import script from "./SSN.vue?vue&type=script&lang=js&"
export * from "./SSN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SSN.vue"
export default component.exports